import React from "react"
import PropTypes from "prop-types"
import SanityImage from "gatsby-plugin-sanity-image"
import CTAButton from "components/buttons/CTAButton"
import Map from "components/Map"
import theme from "styles/theme"

const MapBlock = ({ markers, mobileImage, hqUrl, action }) => {
  const resources = markers.reduce((acc, marker) => {
    acc[marker.resource] = marker.url
    return acc
  }, {})

  return (
    <>
      <Map
        css={{
          maxWidth: 949,
          margin: "40px auto",
          [theme.tablet]: {
            marginTop: 10,
          },
          [theme.mobile]: { display: "none" },
        }}
        resources={resources}
        hqUrl={hqUrl}
      />
      <SanityImage
        {...mobileImage}
        css={{
          display: "none",
          [theme.mobile]: {
            display: "block",
            margin: "32px auto 0",
            width: 300,
          },
        }}
        width={300}
      />
      {action && (
        <div css={{ textAlign: "center" }}>
          <CTAButton href={action.href} css={{ marginTop: 42 }}>
            {action.text}
          </CTAButton>
        </div>
      )}
    </>
  )
}

export default MapBlock

MapBlock.propTypes = {
  markers: PropTypes.arrayOf(
    PropTypes.shape({
      resource: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
  mobileImage: PropTypes.shape({
    asset: PropTypes.object.isRequired,
  }).isRequired,
  action: PropTypes.shape({
    href: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
  }),
}
